import { useMutation } from '@tanstack/react-query'

import { sendBackOnboardingRequest } from '@src/api'
import { DefaultApiSendBackOnboardingRequestRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useSendBackOnboardingRequest = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiSendBackOnboardingRequestRequest) =>
      sendBackOnboardingRequest(axiosInstance, params),
  })
}
